import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollableContentWithHint from '../../widgets/ScrollableContentWithHint';
import { PRESERVE_LINE_BREAKS_SX, SCROLLABLE_DESCRIPTION_SX } from '../eventFormConstants';

const rowLabelSx = {
  flexShrink: 0,
  width: 160,
  color: 'text.primary',
  fontSize: '0.875rem',
  lineHeight: 1.5,
  fontWeight: 400,
};

const rowValueSx = {
  flex: 1,
  minWidth: 0,
  fontWeight: 600,
  color: 'text.primary',
  fontSize: '0.875rem',
  lineHeight: 1.5,
};

const ConfirmationDetailField = ({
  label,
  value,
  children,
  variant = 'stack',
  showColon = true,
  preserveLineBreaks = false,
  scrollable = false,
}) => {
  const useScrollableDescription = scrollable && preserveLineBreaks;
  const lineBreakSx = preserveLineBreaks ? PRESERVE_LINE_BREAKS_SX : null;

  const valueSx = lineBreakSx ? { ...rowValueSx, ...lineBreakSx } : rowValueSx;
  const stackValueSx = lineBreakSx
    ? { fontWeight: 600, color: 'text.primary', lineHeight: 1.5, ...lineBreakSx }
    : { fontWeight: 600, color: 'text.primary', lineHeight: 1.5 };

  const renderStackValue = () => {
    if (useScrollableDescription) {
      return (
        <ScrollableContentWithHint sx={SCROLLABLE_DESCRIPTION_SX}>
          <Typography variant="body2" sx={stackValueSx}>
            {value || '—'}
          </Typography>
        </ScrollableContentWithHint>
      );
    }

    return (
      <Typography variant="body2" sx={stackValueSx}>
        {value || '—'}
      </Typography>
    );
  };
  if (variant === 'row') {
    const labelText = showColon ? `${label}:` : label;

    return (
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.75 }}>
        <Typography component="span" variant="body2" sx={rowLabelSx}>
          {labelText}
        </Typography>
        {children ?? (
          <Typography component="span" variant="body2" sx={valueSx}>
            {value || '—'}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.35 }}>
        {label}
      </Typography>
      {children ?? renderStackValue()}
    </Box>
  );
};

export default ConfirmationDetailField;
